import SectionHeader from "@/components/SectionHeader";
import Button from "@/components/Button";
import ProductCard from "@/components/products/ProductCard";

export default function PopularBoxesSection({
  title,
  subtitle,
  items = [],
  id,
  dataScrollOffset = 100,
  className = "",
  ctaHref = "/fotobox-vergleich",
  // Beschriftung des Knopfs unter der Liste. Auf den Stadtseiten steht dort
  // "Fotobox mieten im Vergleich" und führt auf die Startseite: Sie soll die
  // allgemeine Suche beantworten, und bis auf diesen Link verwies nichts von
  // den 349 Stadtseiten nach oben (Absprache 2026-10-07).
  ctaLabel = "Alle Fotoboxen ansehen",
  noFollow = false,
  noOpener = false,
  postToHrefOnSeo = false,
}) {
  return (
    <section
      id={id}
      data-scroll-offset={dataScrollOffset}
      className={className}
    >
      <SectionHeader title={title} subtitle={subtitle}>
        <div className="mt-10 space-y-4">
          {items.map((item) => (
            <ProductCard key={`${item.name}-${item.href}`} item={item} />
          ))}
        </div>
        <div className="mt-10 flex justify-center">
          <Button
            href={ctaHref}
            variant="primary"
            className="px-8 py-3"
            noFollow={noFollow}
            noOpener={noOpener}
            postToHrefOnSeo={postToHrefOnSeo}
          >
            {ctaLabel}
          </Button>
        </div>
      </SectionHeader>
    </section>
  );
}
